import type { RouteName } from '@atlassian/jira-route-name-types/src/RouteName.tsx';

// These are the routes that we want to pre-eval the issue import in the after paint phase
export const PREEVAL_ROUTES = new Set<RouteName>([
	'archived-projects-directory',
	'archived-project-direct-link',
	'boards-directory',
	'classic-business-board',
	'classic-business-board-embed',
	'classic-business-board-custom-embed',
	'classic-business-calendar',
	'classic-business-calendar-embed',
	'classic-business-calendar-custom-embed',
	'classic-business-form',
	'classic-business-form-submit',
	'classic-business-list',
	'classic-business-list-embed',
	'classic-business-timeline',
	'classic-business-timeline-embed',
	'connect-general',
	'connect-general-invalid',
	'connect-general-service-desk-project',
	'connect-project',
	'dashboards-directory',
	'dashboards-directory-secure',
	'filters-directory',
	'forge-spa-admin',
	'global-issue-navigator',
	'global-settings-issues-custom-fields-view',
	'global-settings-issues-fieldlayouts-view',
	'global-settings-issues-fieldlayouts-schemes-view',
	'global-settings-issues-linktypes-view',
	'global-settings-issues-notification-view',
	'global-settings-issues-permissions-schemes-view',
	'global-settings-issues-priorities',
	'global-settings-issues-resolutions',
	'global-settings-issues-security-schemes',
	'global-settings-issues-statuses',
	'global-settings-issues-field-schemes-view',
	'global-settings-issues-field-screens',
	'global-settings-issues-subtasks-manage',
	'global-settings-issues-time-tracking',
	'global-settings-issues-types-view',
	'global-settings-issues-types-schemes-manage',
	'global-settings-issues-types-screen-schemes-view',
	'global-settings-issues-workflows-pages',
	'global-settings-issues-workflows-schemes-view',
	'issue-embed',
	'knowledge-hub-all-articles',
	'knowledge-hub-article-in-category',
	'knowledge-hub-browse-all-articles',
	'knowledge-hub-browse-view-article',
	'knowledge-hub-category',
	'knowledge-hub-category-page',
	'knowledge-hub-drafts',
	'knowledge-hub-landing',
	'knowledge-hub-search',
	'knowledge-hub-setup',
	'knowledge-hub-suggested-topics',
	'opsgenie-schedule',
	'people-index',
	'personal-settings',
	'polaris-ideas',
	'products-jsw-configuration',
	'projects-directory',
	'project-components',
	'issue-navigator',
	'issue-navigator-classic',
	'issue-navigator-core',
	'project-pages',
	'project-settings-components',
	'project-settings-versions',
	'project-versions',
	'rapidboard-backlog',
	'rapidboard-board',
	'rapidboard-board-embed',
	'rapidboard-report',
	'rapidboard-user-backlog',
	'rapidboard-user-board',
	'rapidboard-user-report',
	'servicedesk-change-calendar',
	'servicedesk-cmdb-configure',
	'servicedesk-cmdb-object',
	'servicedesk-cmdb-object-schema',
	'servicedesk-connect-project',
	'servicedesk-create-project',
	'servicedesk-customers-v2',
	'servicedesk-boards',
	'servicedesk-issues',
	'servicedesk-kb-requests-reports',
	'servicedesk-kb-requests-reports-time-scale-issue',
	'servicedesk-kb-requests-reports-time-scale',
	'servicedesk-oncall-schedule',
	'servicedesk-organization_v2',
	'servicedesk-practice-custom-and-issue',
	'servicedesk-practice-edit',
	'servicedesk-practice-issue',
	'servicedesk-practice-landing',
	'servicedesk-practice-new',
	'servicedesk-queues-addon',
	'servicedesk-queues-custom-view',
	'servicedesk-queues-edit',
	'servicedesk-queues-issue',
	'servicedesk-queues-landing',
	'servicedesk-queues-new',
	'servicedesk-reports',
	'servicedesk-reports-custom',
	'servicedesk-reports-custom-create',
	'servicedesk-reports-custom-edit',
	'servicedesk-reports-custom-time-scale-issue',
	'servicedesk-reports-custom-time-scale',
	'servicedesk-reports-satisfaction',
	'servicedesk-reports-satisfaction-time-scale-issue',
	'servicedesk-reports-satisfaction-time-scale',
	'servicedesk-reports-type',
	'servicedesk-reports-workload',
	'servicedesk-services',
	'servicedesk-service-details',
	'servicedesk-sla-settings',
	'global-settings-issues-cmdb-field-config',
	'admin-oauth-credentials',
	'software-backlog',
	'software-boards',
	'software-code',
	'software-code-classic',
	'software-security',
	'software-security-classic',
	'software-deployments',
	'software-deployments-classic',
	'software-issue-navigator',
	'software-release-notes',
	'software-reports',
	'software-reports-burndown',
	'software-reports-burnup',
	'software-reports-control',
	'software-reports-cumulative',
	'software-reports-velocity',
	'software-roadmap',
	'software-roadmap-classic',
	'software-timeline',
	'software-timeline-classic',
	'system-dashboard-edit',
	'trash-projects-directory',
	'your-work',
]);

export const EXCLUDE_PREEVAL_ROUTES = new Set<RouteName>([
	'global-issue-navigator',
	'issue-navigator',
	'issue-navigator-classic',
	'issue-navigator-core',
	'servicedesk-issues',
	'software-issue-navigator',
	'software-timeline',
	'software-timeline-classic',
]);

// On cleanup of jsw-disable-issue-app-full-page-load, move these to the actual EXCLUDE_PREEVAL_ROUTES definition
export const EXCLUDE_BOARD_BACKLOG_PREEVAL_ROUTES = new Set<RouteName>([
	'software-backlog',
	'software-boards',
	'rapidboard-backlog',
	'rapidboard-board',
]);

export const AFTER_PAINT_ISSUE_PREEVAL_MARK = 'AfterPaintIssuePreEval:rendered';
